import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import VehiclesRoutes from './routes'
import { BackTop } from 'antd'

const propTypes = {}

class Vehicles extends Component {
  render() {
    return (
      <div>
        <BackTop />
        <VehiclesRoutes />
      </div>
    )
  }
}

const mapStateToProps = ({ authentication }, ownProps) => ({
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}), dispatch)
})

Vehicles.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Vehicles))



// WEBPACK FOOTER //
// ./src/containers/vehicles/Vehicles.js